import type { CuisineIconName } from './CuisineIconName'

const cuisineIconMap: Readonly<Record<string, CuisineIconName>> = {
  asian: 'soup',
  bowls: 'soup',
  chinese: 'soup',
  indian: 'soup',
  soups: 'soup',
  thai: 'soup',
  vietnamese: 'soup',

  italian: 'pizza',
  pizza: 'pizza',

  greek: 'leaf',
  'healthy-food': 'leaf',
  mediterranean: 'leaf',
  organic: 'leaf',
  salads: 'salad',
  'smoothies-juices': 'leaf',

  bagels: 'croissant',
  deli: 'sandwich',
  mexican: 'sandwich',
  sandwiches: 'sandwich',
  snacks: 'sandwich',
  tacos: 'sandwich',

  japanese: 'fish',
  poke: 'fish',
  seafood: 'shrimp',
  spanish: 'shrimp',
  sushi: 'fish',

  american: 'flame',
  bbq: 'beef',
  burgers: 'beef',
  caribbean: 'flame',
  chicken: 'flame',
  cuban: 'flame',
  german: 'flame',
  korean: 'flame',
  'south-latin-american': 'flame',
  steakhouse: 'beef',

  bakery: 'cake',
  desserts: 'cake',
  french: 'croissant',
  'ice-cream': 'cake',

  'coffee-and-tea': 'coffee',

  breakfast: 'egg-fried',

  'family-dining': 'utensils'
}

/** Maps a category slug onto the glyph that represents it, falling back to `utensils`. */
export const resolveCuisineIconName = (slug: string): CuisineIconName =>
  cuisineIconMap[slug] ?? 'utensils'
